import React from "react";

import { Box } from "@mui/material";
import OperatoriForm from "./OperatoriForm";
import { useSelector } from "react-redux";



export const OperatoriSlider = ({ cantine, setCantine }) => {
  const singleData = useSelector(
    (state) => state.operatori?.singleOperatori[0]
  );
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una Operatori</h2>
            </Box>
            <OperatoriForm
          cantine={cantine}
          setCantine={setCantine}
          singleData={singleData}
        />
        </Box>
    )
}
